import { format, parseISO } from 'date-fns';

export const EMPTY_INCOME_FORM = {
  source: '', amount: '', description: '', date: new Date(), related_project: '',
  student_first_name: '', student_last_name: '', student_class: '', parent_guardian_name: '', outstanding_balance: '',
  grant_name: '', currency: 'UGX', exchange_rate: 1, original_amount: '',
  sales_cycle: '', items_sold: '', payment_amount: '',
  receipt_image: '', document_name: '',
  program: '', payment_method: '', reference_number: '',
  designation: '', donor: '', funding_source: '',
};

const strOrEmpty = (v) => (v !== null && v !== undefined ? String(v) : '');

export const incomeItemToForm = (item) => ({
  source: item.source || '',
  amount: String(item.amount || ''),
  description: item.description || '',
  date: item.date ? new Date(item.date) : new Date(),
  related_project: item.related_project || '',
  student_first_name: item.student_first_name || '',
  student_last_name: item.student_last_name || '',
  student_class: item.student_class || '',
  parent_guardian_name: item.parent_guardian_name || '',
  outstanding_balance: strOrEmpty(item.outstanding_balance),
  grant_name: item.grant_name || '',
  currency: item.currency || 'UGX',
  exchange_rate: item.exchange_rate || 1,
  original_amount: strOrEmpty(item.original_amount),
  sales_cycle: item.sales_cycle || '',
  items_sold: item.items_sold || '',
  payment_amount: strOrEmpty(item.payment_amount),
  receipt_image: item.receipt_image || '',
  document_name: item.document_name || '',
  program: item.program || '',
  payment_method: item.payment_method || '',
  reference_number: item.reference_number || '',
  designation: item.designation || '',
  donor: item.donor || item.customer || '',
  funding_source: item.funding_source || '',
});

export const buildIncomePayload = (formData) => {
  const isSales = ['chicken_sales', 'garden_produce', 'masonry_sales', 'maize_sales'].includes(formData.source);
  const isGrant = formData.source === 'grants';
  const isMultiCurrency = ['grants', 'donations'].includes(formData.source);
  const isFees = ['school_fees', 'school_fees_collection'].includes(formData.source);

  let primaryAmount = parseFloat(formData.amount || 0);
  if (isSales && formData.payment_amount) primaryAmount = parseFloat(formData.payment_amount);
  if (isMultiCurrency && formData.currency !== 'UGX' && formData.original_amount && formData.exchange_rate) {
    primaryAmount = parseFloat(formData.original_amount) * parseFloat(formData.exchange_rate);
  }

  const payload = {
    source: formData.source,
    amount: primaryAmount,
    date: format(formData.date, 'yyyy-MM-dd'),
    description: formData.description || null,
    related_project: formData.related_project || null,
    receipt_image: formData.receipt_image || null,
    document_name: formData.document_name || null,
    program: formData.program || null,
    payment_method: formData.payment_method || null,
    reference_number: formData.reference_number || null,
    designation: formData.designation || null,
    donor: formData.donor || null,
    funding_source: formData.funding_source || null,
  };

  if (isFees) {
    Object.assign(payload, {
      student_first_name: formData.student_first_name,
      student_last_name: formData.student_last_name,
      student_class: formData.student_class,
      parent_guardian_name: formData.parent_guardian_name,
      outstanding_balance: formData.outstanding_balance ? parseFloat(formData.outstanding_balance) : null,
    });
  } else if (isMultiCurrency) {
    Object.assign(payload, {
      grant_name: isGrant ? formData.grant_name : null,
      currency: formData.currency,
      exchange_rate: parseFloat(formData.exchange_rate || 1),
      original_amount: formData.original_amount ? parseFloat(formData.original_amount) : null,
    });
  } else if (isSales) {
    Object.assign(payload, {
      sales_cycle: formData.sales_cycle,
      items_sold: formData.items_sold ? parseFloat(formData.items_sold) : null,
      payment_amount: formData.payment_amount ? parseFloat(formData.payment_amount) : null,
      outstanding_balance: formData.outstanding_balance ? parseFloat(formData.outstanding_balance) : null,
    });
  }
  return payload;
};

export const formatIncomeDateTime = (dateStr, createdAt) => {
  const date = parseISO(dateStr);
  let timeStr = '';
  if (createdAt) {
    try {
      timeStr = format(parseISO(createdAt), 'h:mm a');
    } catch (e) {
      timeStr = '';
    }
  }
  return { date: format(date, 'EEE, MMM d, yyyy'), time: timeStr };
};
